import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-cream py-12 px-4 relative overflow-hidden" data-id="element-119">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-121">
          <div className="inline-flex items-center justify-center p-3 bg-white rounded-full shadow-sm mb-4 text-coral" data-id="element-122">
            <AlertCircle size={32} data-id="element-123" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-124">
            ¿Por qué tu hijo todavía no deja el pañal?
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white p-6 md:p-10 rounded-3xl shadow-xl shadow-dark-teal/5 border border-light-teal" data-id="element-125">
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-4" data-id="element-126">
            La mayoría de los niños en EE.UU. no dejan el pañal porque el
            mercado nos vende la idea de que{' '}
            <span className="font-semibold text-dark-teal" data-id="element-127">
              "ellos decidirán cuándo"
            </span>
            .
          </p>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-4" data-id="element-128">
            Pero la realidad es que los pañales modernos son tan absorbentes que
            el niño{' '}
            <strong className="text-coral" data-id="element-129">
              nunca siente la incomodidad de estar mojado
            </strong>
            . Su cerebro no tiene una razón biológica para dejar de jugar y
            correr al baño.
          </p>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-130">
            Si a esto le sumas el estrés de los requisitos de los daycares y tu
            propia agenda de trabajo, tienes la receta perfecta para el fracaso
            y la frustración los domingos por la noche.
          </p>
        </motion.div>
      </div>

      {/* Decorative blobs */}
      <div className="absolute top-20 -left-20 w-64 h-64 bg-light-teal/50 rounded-full blur-3xl" data-id="element-131"></div>
      <div className="absolute bottom-10 -right-20 w-80 h-80 bg-coral/5 rounded-full blur-3xl" data-id="element-132"></div>
    </section>;
}